import type { Form } from '~/sanity/types';
export default async function formContainer(props: Form) {
  const formId = props.formId || '';
  const { startingPageType, formSubmitText, redirectLink } = props;
  const { getResolvedInternalLinkRef } = useRefsStore();

  let redirectUrl = '';

  if (redirectLink && redirectLink.length > 0) {
    const link = redirectLink[0];
    if (link._type === 'internalLink' && link.selectedPage?.reference?._ref) {
      // Resolve the Internal Link reference
      const resolvedInternalLink = await getResolvedInternalLinkRef(
        link.selectedPage.reference._ref
      );
      redirectUrl = resolvedInternalLink?.value?.currentPathname || '';
    } else if (link._type === 'externalLink' && link.url) {
      redirectUrl = link.url;
    }
  }
  return (
    <div
      form-id={formId}
      class="formfort-loading formfort-form-container"
      form-variant=""
      ga-action=""
      ga-category=""
      submit-text={formSubmitText}
      redirect-url={redirectUrl}
      hidden-static-field-1={startingPageType}
      hidden-static-field-2=""
    ></div>
  );
}
